/**
 * Formats the data for the JSON file
 */

export const formatDataToJSON = (row, fileName) => {
  const updatedDataArray =
    JSON.parse(localStorage.getItem("UpdatedDataArray")) || [];
console.log("updatedDataArray: ", updatedDataArray);
  //Get the Properties from the UpdatedDataArray in localstorage
  const assignedProperties = row.AssignedProperties
    .split(",")
    .map((prop) => prop.trim().toUpperCase());
  const propertiesData = updatedDataArray.filter(
    (entry) =>
      entry["Property"] &&
    assignedProperties.includes(entry["Property"].toUpperCase())
  );
  const companyName = localStorage.getItem("companyName");
  const snapshotName = localStorage.getItem("selectedSnapshot");

  console.log("propertiesData: ", propertiesData);
  const fileData = {
    FileData: {
      id: row.index,
      DateTime: row.date,
      MemberName: row.MemberName,
      Phone: row.Phone,
      AssignedProperties: row.AssignedProperties,
      RequestFormLink: fileName,
      Status: "In Progress",
      CompanyName: companyName,
      SnapshotName: snapshotName,
      PropertiesData: propertiesData.map((entry) => ({
        "DateTime (per value entry)": entry["DateTime (per value entry)"],
        "Category (per property)": entry["Category (per property)"],
        "Category Tooltip": entry["Category Tooltip"],
        "Property Tooltip": entry["Property Tooltip"],
        "Property": entry["Property"],
        "CompulsoryValue (per property)": entry["CompulsoryValue (per property)"],
        "Value (per property)": "",
        "ValueOptions (per property)": entry["ValueOptions (per property)"],
        "Value Format": entry["Value Format"],
        "Quality (per value)": "",
        "QualityOptions (per value)": entry["QualityOptions (per value)"],
        "Notes (per property)": "",
        "isMerged": false
      })),
    },
  };

  const jsonString = JSON.stringify(fileData, null, 2); //Formatted JSON with 2-space identation
  const blob = new Blob([jsonString], { type: "application/json" });
  return blob;
};
